"use client";
import { jsx } from "react/jsx-runtime";
import { useAnalyticObserverRef } from "../../../../utils/observable/utils.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
function Observable(props) {
  const observableRef = useAnalyticObserverRef(props.observer);
  return /* @__PURE__ */ jsx(CostcoBox, { ref: observableRef, sx: props.sx, children: props.children });
}
export {
  Observable
};
